var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkOutline = function SvgLinkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.808 16.538h-3.77q-1.883 0-3.21-1.328Q2.5 13.884 2.5 12t1.328-3.211 3.21-1.328h3.77v1.5h-3.77q-1.26 0-2.149.89A2.93 2.93 0 0 0 4 11.998q0 1.26.89 2.15.889.889 2.148.889h3.77zM8.25 12.749v-1.5h7.5v1.5zm4.942 3.789v-1.5h3.77q1.26 0 2.149-.89.888-.888.889-2.149 0-1.26-.89-2.149a2.93 2.93 0 0 0-2.148-.89h-3.77v-1.5h3.77q1.883 0 3.21 1.328 1.328 1.327 1.328 3.21t-1.328 3.212-3.21 1.328z"
  })));
};
export default SvgLinkOutline;